import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { useI18n } from "../lib/i18n";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { toast } from "sonner";
import { formatApiErrorDetail } from "../lib/api";

export default function Login() {
  const { login } = useAuth();
  const { t } = useI18n();
  const nav = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const u = await login(form.email, form.password);
      toast.success("Welcome back");
      const isStaff = u.role === "admin" || u.role === "manager";
      if (u.must_change_password) nav(isStaff ? "/admin?changepw=1" : "/dashboard?changepw=1");
      else if (isStaff) nav("/admin");
      else nav("/dashboard");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-6">
      <form onSubmit={submit} className="w-full max-w-md rounded-2xl border border-white/10 bg-[#0A1128] p-10">
        <div className="text-xs tracking-[0.3em] uppercase text-[#D4AF37] mb-2">Sam Taxi</div>
        <h1 className="font-heading text-3xl mb-6 text-white">{t("nav.login")}</h1>
        <div className="space-y-4">
          <div>
            <Label className="text-white/70">Email</Label>
            <Input data-testid="login-email" required type="email" value={form.email} onChange={(e) => setForm({...form, email: e.target.value})} className="bg-[#040814] border-white/20 text-white h-12" />
          </div>
          <div>
            <Label className="text-white/70">Password</Label>
            <Input data-testid="login-password" required type="password" value={form.password} onChange={(e) => setForm({...form, password: e.target.value})} className="bg-[#040814] border-white/20 text-white h-12" />
          </div>
          <Button data-testid="login-submit" type="submit" disabled={busy} className="w-full h-12 bg-[#D4AF37] hover:bg-[#B5952F] text-[#040814] font-semibold">
            {busy ? "..." : t("nav.login")}
          </Button>
          <div className="text-center text-sm text-white/60">
            No account? <Link to="/register" className="text-[#D4AF37]">{t("nav.register")}</Link>
          </div>
        </div>
      </form>
    </div>
  );
}
